var billingDeliveryModule = (function (_app, _BaseView, _FieldView, _NewAddressForm) {
    
    var hiddenClass = 'hidden-block';

    var _forms = {
        current: 1,
        new: 2,
        list: 3
    };

    var _eventHandler = $({});
    var _changeEventName = 'changeActiveForm';
    var _activeForm = null;

    var _Router = function () {

        var _currentAddressID = null;
        
        var _setActiveForm = function (form) {
            _activeForm = form;
            _eventHandler.trigger(_changeEventName, form);
        }

        var _update = function(address) {
            _currentAddressID = address && address.ID || null;
            _activeForm = (_currentAddressID ? _forms.current : _forms.new);
            _setActiveForm(_activeForm);
        }

        var _updateByChangeID = function (address) {
            if (_currentAddressID !== (address && address.ID || null)) {
                _update(address);
            }
        }

        app.models.delivery.billingAddress.ready().done(_update);

        app.models.delivery.billingAddress.onUpdate(_updateByChangeID);

        return {
            getActiveForm: function() {
                return _activeForm;
            },
            setActiveForm: _setActiveForm,
            onChangeActiveForm: function(fn) {
                if ($.isFunction(fn)) {
                    _eventHandler.on(_changeEventName, fn);
                }
            }
        };
    };

    var _router = _Router();

    var BillingDeliveryView = _BaseView.extend({
        el: '@billingAddress',

        events: {
            'click @btnChangeBillingAddress': '_showNewAddressForm',
            'click @btnAddBillingAddressForm': '_showNewAddressForm'
        },

        initialize: function () {
            _.bindAll(this, '_switchFormMode', '_showNewAddressForm');

            if (this.settings('GiftEnabled')) {
                this.onChangeDeliverySectionMode(this._switchFormMode);
                this._switchFormMode();
            } else {
                this.$el.addClass(hiddenClass);
            }

        },

        _switchFormMode: function (e, mode) {
            mode = mode || this.getDeliverySectionMode();
            this.$el.toggleClass(hiddenClass, mode !== this.deliverySectionMode.gift);
        },

        _showNewAddressForm: function (e) {
            e && e.preventDefault();
            _router.setActiveForm(_forms.new);
        }
    });

    var NewBillingAddressView = Backbone.View.extend({
        el: '@newBillingDelivery',

        events: {
            'click @btnAddBillingAddress': 'addAddress',
            'click @btnCancelNewBillingAddress': '_showCurrentBillingAddress'
        },

        initialize: function () {
            _.bindAll(this);
            this.$fields = this.$('@billingFields');
            this.$btnAddAddress = this.$('@btnAddBillingAddress');
            this.$btnCancelNewBillingAddress = this.$('@btnCancelNewBillingAddress');

            _router.onChangeActiveForm(_.bind(this._toggle, this));
            this._toggle(null, _router.getActiveForm());

            if (!IsAuthorized()) {
                this.$btnAddAddress.remove();
            } else {
                this.collection.on('inProgress', this._inProgress);
            }

            this.collection.ready(this._render);
        },

        _render: function () {
            this.form = _NewAddressForm(this.collection, _FieldView, this.$fields);
            this.form.render();
        },

        _toggle: function (e, form) {
            var isActive = form === _forms.new;

            this.collection.setActive(isActive);

            this.$btnCancelNewBillingAddress.toggleClass(hiddenClass, !app.models.delivery.billingAddress.get('ID'));

            this.$el.toggle(isActive);
        },

        _showCurrentBillingAddress: function (e) {
            e.preventDefault();
            _router.setActiveForm(_forms.current);
        },

        addAddress: function (e) {
            e.preventDefault();
            /**
             * / Replace to useThisGiftAddress
             */
            //_app && _app.event && _app.event.useThisAddress();
            this.collection.save();
        },

        _inProgress: function (state) {
            this.$btnAddAddress.toggleClass('checkout-button-add-address', !state);
            this.$btnAddAddress.toggleClass('checkout-button-add-address__processing', state);
        }
    });

    var CurrentBillingAddressView = Backbone.View.extend({
        el: '@lastBillingAddressContainer',
        initialize: function () {
            _.bindAll(this);
            this.$lastAddress = this.$('@lastBillingAddress');

            _router.onChangeActiveForm(_.bind(this._toggle, this));
            this._toggle(null, _router.getActiveForm());
            this.render();
            this.model.on('change', this.render);
        },

        render: function () {
            this.$lastAddress.html($.tmpl('bt-checkout-delivery-address', this.model.toJSON()));
        },
        _toggle: function (e, form) {
            var isActive = form === _forms.current;
            this.model.setActive(isActive);
            this.$el.toggle(isActive);
        }
    });

    new NewBillingAddressView({ collection: app.models.delivery.billingDecoration });
    new CurrentBillingAddressView({ model: app.models.delivery.billingAddress });

    new BillingDeliveryView();
});